import axios from 'axios'
//import txt from 'raw-loader!../static/webconn.config';

//let strDatabaseServer="http://localhost:50130";
//let strDatabaseServer = "https://localhost:44397";
//let strDatabaseServer="http://qa.netcar.cl";
//let strDatabaseServer="http://netcar3.xxi.cl/";
//let strDatabaseServer="http://netcar3.valdelarze.cl/";
let strDatabaseServer = "http://puente.xxi.cl/";
//let strDatabaseServer = "http://taller.netcarportillosur.com/";
//let strDatabaseServer = "http://qa.netcarportillosur.com/";
//let strDatabaseServer = "http://netcarportillosur.com/";
//let strDatabaseServer = "http://puente.valenzueladelarze.cl/";
//let strDatabaseServer = "http://mw.netcar.cl";
//let strDatabaseServer = "https://netcarportillosur.com";
//return this.$store.state.db;
//alert(JSON.parse(localStorage.getItem('user')).database);
// let strDatabase=JSON.parse(localStorage.getItem('user')).database;

let strDatabase;

let userData = JSON.parse(localStorage.getItem('user'));

if (userData !== null && userData.hasOwnProperty('database')) {
    strDatabase = userData.database;
} else {
    console.error("No se encontraron datos de usuario en el almacenamiento local o no se encontró la propiedad 'database'.");
}

function GetErr(strMsgErr)
{

    switch (strMsgErr) {
        case 'The password is invalid or the user does not have a password.':
            return 'Error al iniciar sesión, favor verifique e-mail y contraseña.';            
            break;
        case "There is no user record corresponding to this identifier. The user may have been deleted.":
            return  'El E-mail no se encuentra en nuestros registros, favor verifique el correo para reestablecer la contraseña.';
            break;
        case "Password should be at least 6 characters":
            return  'La contraseña debe tener mínimo 6 caracteres.';
            break;
        case "The email address is already in use by another account.":
            return  'El E-mail ya se encuentra en uso por otra cuenta.';
            break;
        case "The password is invalid or the user does not have a password.":
            return  'La contraseña no es válida.';
            break;
        case "Too many unsuccessful login attempts. Please try again later.":
            return  'Demasiados intentos de inicio de sesión fallidos. Por favor, inténtelo de nuevo más tarde.';
            break;
        default:
            return 'Se ha producido un error, favor intente nuevamente.';
            //return strMsgErr;// 'Se ha producido un error, favor intente nuevamente.';
            break;            
    }
}

function getServerHTTP(){
return (strDatabaseServer)
}

function getQuery(strSql,istesting){
    var strDatabaseServerGet=strDatabaseServer+"/http/getQuery.aspx";
    var bodyFormData = new FormData();

    bodyFormData.set('query', strSql);
    bodyFormData.set('istesting', istesting);
    bodyFormData.set('database', strDatabase);    
    
	return axios({ method: "POST", "url": strDatabaseServerGet,data: bodyFormData,headers: {'Content-Type': 'multipart/form-data'}});
}

function ExecuteQuery(strSql){
    var strDatabaseServerGet=strDatabaseServer+"/http/getQuery.aspx";
    var bodyFormData = new FormData();

    bodyFormData.set('query', strSql);
    bodyFormData.set('isexecute', true);
    bodyFormData.set('database', strDatabase);    

	return axios({ method: "POST", "url": strDatabaseServerGet,data: bodyFormData,headers: {'Content-Type': 'multipart/form-data'}});
}

function getDataForm(DataForm,strParams){

    var i;
    var strField="";    
    var strFields="";    
    var strDatabaseServerGet=strDatabaseServer+"/http/getFx.aspx";
    var bodyFormData = new FormData();

    var intLen = DataForm.elements.length - 1		
    for (var i = 0; i <= intLen; i++)
        {
        if(DataForm.elements[i].name.substring(0,6)=="field_")
            {
                strField=DataForm.elements[i].name
                strField=strField.substring(6)+' '+ DataForm.elements[i].id
                strFields=strFields+strField+","
            }

        }

    bodyFormData.set("Fields", strFields);
    bodyFormData.set('fx', "getdataform");
    bodyFormData.set('params', strParams);
    bodyFormData.set('database', strDatabase);    

    return axios({ method: "POST", "url": strDatabaseServerGet,data: bodyFormData,headers: {'Content-Type': 'multipart/form-data'}});   
}

function sendDataForm(DataForm,strParams){
        var i;
        var strDatabaseServerGet=strDatabaseServer+"/http/getFx.aspx";
        var bodyFormData = new FormData();
        
        var intLen = DataForm.elements.length - 1		
        for (var i = 0; i <= intLen; i++)
            {
            if(DataForm.elements[i].name!="")
                bodyFormData.set(DataForm.elements[i].name, DataForm.elements[i].value);
            }
    
        bodyFormData.set('fx', "senddataform");
        bodyFormData.set('params', strParams);
        bodyFormData.set('database', strDatabase);    
    
        return axios({ method: "POST", "url": strDatabaseServerGet,data: bodyFormData,headers: {'Content-Type': 'multipart/form-data'}});   
}

function sendDataForm2(DataForm,strParams){
    var i;
    var strDatabaseServerGet=strDatabaseServer+"/http/getFx2.aspx";
    var bodyFormData = new FormData();
            
    var intLen = DataForm.elements.length - 1		
    for (var i = 0; i <= intLen; i++)
    {
        if(DataForm.elements[i].name!="")
        bodyFormData.set(DataForm.elements[i].name, DataForm.elements[i].value);
    }
        
    bodyFormData.set('fx', "senddataform");
    bodyFormData.set('params', strParams);
    bodyFormData.set('database', strDatabase);    
        
    return axios({ method: "POST", "url": strDatabaseServerGet,data: bodyFormData,headers: {'Content-Type': 'multipart/form-data'}});   
}

function envioFechaAsesor(DataForm,strParams){
    var i;
    var strDatabaseServerGet=strDatabaseServer+"/http/getFx2.aspx";
    var bodyFormData = new FormData();
            
    var intLen = DataForm.elements.length - 1		
    for (var i = 0; i <= intLen; i++){
        if(DataForm.elements[i].name!="")
        bodyFormData.set(DataForm.elements[i].name, DataForm.elements[i].value);
    }
        
    var valorKilometraje = document.getElementById("Kilometraje").value || "0";
    bodyFormData.set('kilometraje', valorKilometraje);

    bodyFormData.set('fx', "fechaEntregaOTAsesor");
    bodyFormData.set('params', strParams);
    bodyFormData.set('database', strDatabase); 
    bodyFormData.set('fechaentregaot', document.getElementById("fechaentregaot").value); 
        
     return axios({ method: "POST", "url": strDatabaseServerGet,data: bodyFormData,headers: {'Content-Type': 'multipart/form-data'}});   
}  

function getFx(strFx,strParams){
    var strDatabaseServerGet=strDatabaseServer+"/http/getFx.aspx";
	var bodyFormData = new FormData();

    try {
        //var obj = JSON.parse('{ "name":"John", "age":30, "city":"New York"}');
        var obj = JSON.parse(strParams);
        }
    catch(err) {
        alert('error en JSON de parámetros');
    }

	bodyFormData.set('fx', strFx);
	bodyFormData.set('params', strParams);
    bodyFormData.set('database', strDatabase);    
	//bodyFormData.set('istesting', istesting);

	return axios({ method: "POST", "url": strDatabaseServerGet,data: bodyFormData,headers: {'Content-Type': 'multipart/form-data'}});
}

function getFx2(strFx,strParams, photosBlobs = {}){
    var strDatabaseServerGet=strDatabaseServer+"/http/getFx2.aspx";
	var bodyFormData = new FormData();

    try {
        //var obj = JSON.parse('{ "name":"John", "age":30, "city":"New York"}');
        var obj = JSON.parse(strParams);
        }
    catch(err) {
        alert('error en JSON de parámetros');
    }

	bodyFormData.set('fx', strFx);
	bodyFormData.set('params', strParams);
    bodyFormData.set('database', strDatabase);    
	//bodyFormData.set('istesting', istesting);

    const shouldModifyUrl = strFx === "ot.saveimagevehiculo" || strFx === "ot.saveimagesign" || strFx === "ot.GuardarImagenesDelVehiculo" || strFx === "ot.getImagenesOTVehiculo" || strFx === "ot.saveimageFirmReciboConformidad" || strFx === "ot.saveimageFirmCertificadoMantencion";

    // Cambiar la URL si es necesario
    if (shouldModifyUrl) {
        if (strDatabaseServerGet.startsWith("http://puente.xxi.cl/")) {
            strDatabaseServerGet = strDatabaseServerGet.replace("http://puente.xxi.cl/", "http://xxi.netcar.cl/");
        }

        if (strDatabaseServerGet.startsWith("http://puente.valenzueladelarze.cl/")) {
            strDatabaseServerGet = strDatabaseServerGet.replace("http://puente.valenzueladelarze.cl/", "http://vyd.netcar.cl/");
        }
    }

    if (strFx === "ot.GuardarImagenesDelVehiculo") {
        Object.entries(photosBlobs).forEach(([angle, blob]) => {
            const fileName = `img_${angle}_OT_${JSON.parse(strParams).idcotizacionvehiculo}.jpg`;
    
            // Verificar si es un Blob (imagen convertida desde base64) o una URL
            if (blob instanceof Blob) {
                // Si es un Blob (base64), lo agregamos directamente
                bodyFormData.append(`photos[${angle}]`, blob, fileName);
            } else {
                // Si es una URL de imagen (ya subida), la agregamos como texto
                bodyFormData.append(`photos[${angle}]`, blob);
            }
        });
    }

	return axios({ method: "POST", "url": strDatabaseServerGet, data: bodyFormData,headers: {'Content-Type': 'multipart/form-data'}});
}

function getFx3(strFx,strParams){
    var strDatabaseServerGet=strDatabaseServer+"/http/getFx3.aspx";
	var bodyFormData = new FormData();

    try {
        //var obj = JSON.parse('{ "name":"John", "age":30, "city":"New York"}');
        var obj = JSON.parse(strParams);
        }
    catch(err) {
        alert('error en JSON de parámetros');
    }

	bodyFormData.set('fx', strFx);
	bodyFormData.set('params', strParams);
    bodyFormData.set('database', strDatabase);    
	//bodyFormData.set('istesting', istesting);
	return axios({ method: "POST", "url": strDatabaseServerGet,data: bodyFormData,headers: {'Content-Type': 'multipart/form-data'}});
}
    
function getAuth(database,user,pwd){
    var strDatabaseServerGet=strDatabaseServer+"/http/getAuth.aspx";
    var bodyFormData = new FormData();
    bodyFormData.set('database', database);
    bodyFormData.set('user', user);
    bodyFormData.set('pwd', pwd);

    return axios({ method: "POST", "url": strDatabaseServerGet,data: bodyFormData,headers: {'Content-Type': 'multipart/form-data'}});
}

function Now(){
    let date = new Date()

    let day = date.getDate()
    let month = date.getMonth() + 1
    let year = date.getFullYear()

    if(month < 10) month="0"+month; 
    if(day < 10) day="0"+day; 

    return `${day}/${month}/${year}`
}

function Fechaextendida(strFecha){
    let day = parseInt(strFecha.substring(0,2))
    let month = parseInt(strFecha.substring(3,5))
    let year = strFecha.substring(6,10)

    var arrMonth=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"]

    month=arrMonth[month-1]

    return `${day} de ${month} ${year}`
}

function Mescalendario(strFecha){
    let month = parseInt(strFecha.substring(3,5))

    var arrMonth=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"]

    month=arrMonth[month-1]

    return `${month}`
}

  /*	  
	axios({ method: "POST", "url": strDatabaseServer,data: bodyFormData,headers: {'Content-Type': 'multipart/form-data'}}).then(result => {
		if (result.data.err!="")
		{
		alert(result.data.err);
		console.log (result.data.err);
		}
		else{
			alert(result.data.data);
			arrret.push(result.data.data);// = []; resolve(result);
		}
		}, error => {
			console.error(error);
		});
		return arrret;
*/


export {
    getServerHTTP,
    Now,
    Mescalendario,
    Fechaextendida,
	GetErr,
    getAuth,    
    getQuery,
    ExecuteQuery,
    getDataForm,
    sendDataForm,
    sendDataForm2,
    //Netcar
    getFx,
    // Report View
    getFx2,
    // NetcarApp
    getFx3, 
    envioFechaAsesor
}
